import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Button, Icon} from '@goguardian/based';
import {Link} from 'react-router';
import Clipboard from 'react-zeroclipboard';
import cn from 'classnames';
const env = process.env;

import style from './style.scss';

class Select extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      licenseId: this.props.ext_tag,
      licenseURL: env.dashboardRoot + '/licenses/update.php',
      extensionId: 'haldlgldplgnggkjaafhelgiaglafanh',
      extensionURL: env.dashboardRoot + '/ext/m.xml'
    }
  }

  render() {
    const saveSettings = cn([style.saveSettings], [style.imageWindow]);

    return (
      <div className={style.step}>
        <div className={style.stepHeader}>
          <Link to="/getting-started/select"><Icon value="arrow-left"/></Link>

          <h1>Step 4 of 5</h1>
          <h2>Deploy</h2>
        </div>

        <div className={style.stepContent}>
          <p>Add both required extensions to the force-install list.</p>

          <div className={style.extensions}>
            <h4>Extension 1</h4>

            <div className={style.field}>
              <label>ID</label>
              <input type="text" value={this.state.licenseId} readOnly onClick={this.focus} />
              <Clipboard text={this.state.licenseId}>
                <Button><i className="fa fa-clipboard"></i> Copy</Button>
              </Clipboard>
            </div>

            <div className={style.field}>
              <label>URL</label>
              <input type="text" value={this.state.licenseURL} readOnly onClick={this.focus} />
              <Clipboard text={this.state.licenseURL}>
                <Button><i className="fa fa-clipboard"></i> Copy</Button>
              </Clipboard>
            </div>
          </div>

          <div className={style.extensions}>
            <h4>Extension 2</h4>

            <div className={style.field}>
              <label>ID</label>
              <input type="text" value={this.state.extensionId} readOnly onClick={this.focus} />
              <Clipboard text={this.state.extensionId}>
                <Button><i className="fa fa-clipboard"></i> Copy</Button>
              </Clipboard>
            </div>

            <div className={style.field}>
              <label>URL</label>
              <input type="text" value={this.state.extensionURL} readOnly onClick={this.focus} />
              <Clipboard text={this.state.extensionURL}>
                <Button><i className="fa fa-clipboard"></i> Copy</Button>
              </Clipboard>
            </div>
          </div>

          <div className={style.figureContent}>
            <p>Select the <strong>Save</strong> button to save your settings.</p>
            <div className={style.figureContain}>
              <div className={saveSettings}></div>
            </div>
          </div>

          <Link to="/getting-started/finish"><Button block>Next</Button></Link>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  let ext_tag;
  if (state.createAccount) {
    ext_tag = state.createAccount.org.ext_tag;
  }
  return {
    ext_tag: ext_tag,
  }
};

export default connect(mapStateToProps)(Select);



/** WEBPACK FOOTER **
 ** ./src/app/components/gettingStarted/deploy/index.jsx
 **/